import { makeStyles } from '@material-ui/core';

export const sendEstimateModalStyles = makeStyles(theme => ({
    content: {
        padding: theme.spacing(2),
        minWidth: 420,
    },
    fields: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: theme.spacing(2),
    },
    actions: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: theme.spacing(1),
        paddingTop: theme.spacing(3),
    },
}));
